<!-- Navbar uniforme style CAC pour CAS et CAC -->
<div class="wizard-nav-container">
  <p-menubar [model]="items">
    <ng-template pTemplate="start">
      <div class="logo mr-3">
        <img *ngIf="config.logoPath" [src]="config.logoPath" alt="Logo" height="40" class="mr-2">
        <img *ngIf="!config.logoPath" src="assets/images/file.png" alt="Logo" height="40" class="mr-2">
        <span class="font-bold text-lg">{{ config.moduleName }}</span>
      </div>
      
      <!-- Boutons de module CAC/CAS centrés -->
      <div *ngIf="isAuthenticated" class="module-buttons-center">
        <div class="module-buttons-inline">
          <button
            pButton
            label="CAC"
            [class.active]="selectedModule === 'CAC'"
            class="module-button p-button-outlined p-button-sm"
            (click)="switchToModule('CAC')"
          ></button>
          <button
            pButton
            label="CAS"
            [class.active]="selectedModule === 'CAS'"
            class="module-button p-button-outlined p-button-sm"
            (click)="switchToModule('CAS')"
          ></button>
        </div>
      </div>
    </ng-template>
    <ng-template pTemplate="end">
      <div class="flex align-items-center">
        <!-- Notification Bell -->
        <app-notification-dropdown *ngIf="isAuthenticated"></app-notification-dropdown>

        <!-- Bouton Profil (seulement si connecté) -->
        <div *ngIf="isAuthenticated">
          <button
            pButton
            type="button"
            class="p-button-text ml-2 profile-button"
            (click)="goToProfile()"
          >
            <p-avatar 
              *ngIf="hasUserPhoto()"
              [image]="getUserPhotoUrl()" 
              shape="circle"
              size="normal"
              styleClass="mr-2"
            ></p-avatar>
            <p-avatar 
              *ngIf="!hasUserPhoto()"
              [label]="getUserInitials()" 
              shape="circle"
              size="normal"
              styleClass="mr-2 avatar-initials"
            ></p-avatar>
            <span class="username-text">{{ getUserDisplayName() }}</span>
          </button>
        </div>

        <!-- Bouton de connexion (seulement si non connecté) -->
        <div *ngIf="!isAuthenticated && !isLoginPage">
          <button
            pButton
            label="Connexion"
            icon="pi pi-sign-in"
            class="p-button-outlined"
            routerLink="/login"
          ></button>
        </div>
      </div>
    </ng-template>
  </p-menubar>
</div>